var app = globalThis;
globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};

appCustomerSpace.ModalAddOnePricing = (function(superClass) {
  utils.extend(ModalAddOnePricing, superClass);

  function ModalAddOnePricing() {
    return ModalAddOnePricing.__super__.constructor.apply(this, arguments);
  }

  ModalAddOnePricing.prototype.init = function() {
    return ModalAddOnePricing.__super__.init.apply(this, arguments);
  };

  ModalAddOnePricing.prototype.callbackSuccess = function(data, successMsg) {
    var $container, $target;
    if (data.response && this.$html.data('target')) {
      $container = $(this.$html.data('target'));

      if(app.currentModalOpener && app.currentModalOpener.$html.closest('.price').length) {
        app.currentModalOpener.$html.closest('.price').replaceWith(data.html);
      } else {
        $container.append(data.html);
      }

      appCustomerSpace.creationForm.currentStep.handleItemArrows($container);
      appCustomerSpace.LimitlessPlugins.initPlugins($container);

      $('body').trigger('job_form.change', [$container.parent()]);
    }

    return ModalAddOnePricing.__super__.callbackSuccess.call(this, data);
  };

  return ModalAddOnePricing;

})(appCustomerSpace.Modal);
